export class AdvancedFiltersItem<T> {
    extractProperty: (item: T) => any;
    filterName: string;
    value: any;
    type: 'multicheck';
}

export class AdvancedFilters<T> {
    constructor(public filterItems: AdvancedFiltersItem<T>[]) {

    }
}


// WEBPACK FOOTER //
// ./src/components/trend-explorer/tags-filter/AdvancedFilters.ts